import React, { useState, useEffect } from 'react';
import { Table, Button, Space, Modal, Form, Input, Switch, Popconfirm, Typography, message } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { geoApi, District } from '../../api/geo';

const { Title } = Typography;

const DistrictsList: React.FC = () => {
  const [data, setData] = useState<District[]>([]);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState<{ mode: 'create' | 'edit'; item?: District } | null>(null);
  const [form] = Form.useForm();

  const fetch = async () => {
    setLoading(true);
    try {
      const res = await geoApi.listDistricts();
      setData(res.data);
    } catch { message.error('Ошибка загрузки'); }
    setLoading(false);
  };

  useEffect(() => { fetch(); }, []);

  const handleSubmit = async () => {
    const values = await form.validateFields();
    try {
      if (modal?.mode === 'edit' && modal.item) {
        await geoApi.updateDistrict(modal.item.id, values);
        message.success('Район обновлён');
      } else {
        await geoApi.createDistrict(values);
        message.success('Район создан');
      }
      setModal(null);
      form.resetFields();
      fetch();
    } catch { message.error('Ошибка сохранения'); }
  };

  const handleDelete = async (id: number) => {
    try {
      await geoApi.deleteDistrict(id);
      message.success('Район удалён');
      fetch();
    } catch { message.error('Ошибка удаления'); }
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', width: 60 },
    { title: 'Название (рус)', dataIndex: 'name_ru' },
    { title: 'Название (каз)', dataIndex: 'name_kk' },
    {
      title: 'Активен', dataIndex: 'is_active', width: 100,
      render: (v: boolean) => v ? '✓' : '—',
    },
    {
      title: 'Действия', width: 120,
      render: (_: any, record: District) => (
        <Space>
          <Button size="small" icon={<EditOutlined />} onClick={() => {
            form.setFieldsValue(record);
            setModal({ mode: 'edit', item: record });
          }} />
          <Popconfirm title="Удалить район?" onConfirm={() => handleDelete(record.id)}>
            <Button size="small" danger icon={<DeleteOutlined />} />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
        <Title level={4} style={{ margin: 0 }}>Районы</Title>
        <Button type="primary" icon={<PlusOutlined />} onClick={() => {
          form.resetFields();
          setModal({ mode: 'create' });
        }}>Добавить</Button>
      </div>

      <Table columns={columns} dataSource={data} rowKey="id" loading={loading}
        pagination={false} size="middle" />

      <Modal
        open={!!modal}
        title={modal?.mode === 'edit' ? 'Редактировать район' : 'Новый район'}
        onCancel={() => setModal(null)}
        onOk={handleSubmit}
        okText="Сохранить"
        cancelText="Отмена"
      >
        <Form form={form} layout="vertical">
          <Form.Item name="name_ru" label="Название (рус)" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="name_kk" label="Название (каз)">
            <Input />
          </Form.Item>
          {modal?.mode === 'edit' && (
            <Form.Item name="is_active" label="Активен" valuePropName="checked">
              <Switch />
            </Form.Item>
          )}
        </Form>
      </Modal>
    </div>
  );
};

export default DistrictsList;
